import { eUserRole } from '../../../../providers/UserProvider/User.enums';
import { tRoleOption, tTeamContext } from './Team.types';
import { eSeatFlowOutcome } from './Team.enums';
import { eSeatQuoteUnavailable } from 'src/providers/SubscriptionProvider/useSeatPurchase.types';

export const TEAM_INITIAL_STATE: tTeamContext = {
  addTeamMemberModalIsOpen: false,
  seatPurchaseRequired: false,
  openAddTeamMemberModal: () => {},
  closeAddTeamMemberModal: () => {},
  seatFlowOutcome: eSeatFlowOutcome.NONE,
  seatFlowMessage: null,
  seatPurchase: {
    isReady: false,
    quote: {
      available: false,
      reason: eSeatQuoteUnavailable.SUBSCRIPTION_NOT_ELIGIBLE,
    },
    amountDueToday: { known: false },
    isLoadingAmountDueToday: false,
    isPurchasing: false,
    purchaseOneSeat: async () => ({
      status: 'failed' as const,
      message: '',
      declined: false,
    }),
    resetPurchaseIntent: () => {},
  },
  isCardCaptureOpen: false,
  openCardCapture: () => {},
  setSeatQuoteEnabled: () => {},
  showEditUserModal: false,
  toggleEditUserModal: () => {},
  addUserFormik: undefined,
  editUserFormik: undefined,
  deleteUserFormik: undefined,
  showUserCreatedModal: false,
  toggleUserCreatedModal: () => {},
  showExistentUserModal: false,
  toggleExistentUserModal: () => {},
  pipesSelectionOptions: [],
  inboxIsActiveForAnyUser: false,
  toggleUserInbox: () => Promise.resolve(),
  resendUserInvitation: () => Promise.resolve(),
  showDeleteModal: false,
  toggleDeleteModal: () => {},
  userToDelete: null,
  setUserToDelete: () => {},
  deletingUser: false,
  addingUser: false,
  updatingUser: false,
  userToEdit: null,
  setUserToEdit: () => {},
  showConfirmEditUserModal: false,
  setShowConfirmEditUserModal: () => {},
  toggleUserCreatedModalV2: false,
  setToggleUserCreatedModalV2: () => {},
  addedUserName: null,
  setAddedUserName: () => {},
};

/*
 * BUG-801: how long the cross-account 403 toast stays readable before the
 * reload that hands recovery to UserProvider's boot-time reconciliation guard.
 */
export const SESSION_MISMATCH_RELOAD_DELAY_MS = 3_000;

export const ROLE_OPTIONS: tRoleOption[] = [
  {
    value: eUserRole.ADMIN,
    label: eUserRole.ADMIN,
  },
  {
    value: eUserRole.SELLER,
    label: eUserRole.SELLER,
  },
];
